/**
 * SubscribersActivityReportsCtrl controller
 *
 * @class SubscribersActivityReportsCtrl
 * @memberof mwApp/subscribersActivityReports
 * @see mwApp/subscribersActivityReports
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribersReports.controller:SubscribersActivityReportsCtrl
 */

/* @ngInject */
export default function SubscribersActivityReportsCtrl ($scope, authSvc) {
  var vm = this

  vm.mixes = authSvc.hasAccess('createSubscriberActivityReport')
    ? [['tabsCtrlMixin', '', 'generated_reports']]
    : [['tabsCtrlMixin', '']]

  /**
   * Methods to change tab
   *
   * @memberof mwApp/reports.controller:SubscribersActivityReportsCtrl
   */
  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
